
import { FilterPoint } from "../types/types";
import { filterTypes } from "./filtertypes";

export const setFilterAction = (filter: FilterPoint) => (
    {
        type:  filterTypes.SET_FILTER,
        payload: filter
    }
)